module.exports = __webpack_public_path__ + "static/media/bunzl.c210dcb2.png";